(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const select = root.querySelector('[data-city-select]');
    root.addEventListener('click', event => {
      const link = event.target.closest('[data-track]');
      if (!link || link.type === 'submit') return;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({event:'halloween_cta_click',campaign:'halloween_glow_nights_2026',brand:root.dataset.brand,placement:link.dataset.track,city:select?.value || null});
    });
    root.querySelector('form')?.addEventListener('submit', event => {
      if (!event.target.checkValidity()) return;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({event:'halloween_signup_submit',campaign:'halloween_glow_nights_2026',brand:root.dataset.brand});
    });
    if (!select) return;
    const data = JSON.parse(root.querySelector('[data-workshop-data]').textContent);
    const messages = JSON.parse(root.querySelector('[data-workshop-messages]').textContent);
    select.disabled = false;
    select.addEventListener('change', () => {
      const city = select.value;
      const name = select.options[select.selectedIndex].textContent;
      root.querySelectorAll('[data-workshop]').forEach((card, index) => {
        const item = data[city]?.[index];
        const available = item?.exists && item.url;
        card.querySelector('[data-card-city]').textContent = name;
        card.querySelector('[data-card-price]').textContent = available ? item.price : '—';
        card.querySelector('[data-card-pricing]').hidden = !available;
        card.querySelector('[data-card-fallback]').hidden = !!available;
        card.querySelector('[data-card-label]').textContent = available ? messages.view_dates : messages.unavailable;
        card.querySelectorAll('[data-card-link]').forEach(link => {
          link.href = available ? item.url : root.dataset.fallbackUrl;
          link.setAttribute('aria-label', available ? `${messages.view_dates}: ${item.title}` : messages.unavailable);
        });
      });
      root.querySelector('[data-city-note]').textContent = city === 'brisbane' ? messages.brisbane : messages.other;
      root.querySelector('[data-city-status]').textContent = `${messages.updated} ${name}`;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({event:'halloween_city_select',campaign:'halloween_glow_nights_2026',brand:root.dataset.brand,city});
    });
  }
  document.querySelectorAll('[data-halloween]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-halloween]').forEach(init));
})();
